import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./index.css";
import { loadCriticalPolyfills } from "./utils/polyfillLoader";

// Initialize polyfills for compatibility
let needsPolyfills = false; // Simplified - load polyfills for all browsers

// Initialize the app
const initializeApp = async () => {
  try {
    // Load critical polyfills if needed
    if (needsPolyfills) {
      await loadCriticalPolyfills();
    }

    // Create query client with optimizations for legacy browsers
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: false,
          // Optimize for legacy browsers
          staleTime: 5 * 60 * 1000, // 5 minutes
          gcTime: 10 * 60 * 1000 // 10 minutes
        }
      }
    });

    // Render the app
    ReactDOM.createRoot(document.getElementById("root")!).render(
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    );
  } catch (error) {
    console.error("Failed to initialize app:", error);

    // Show fallback message for critical failures
    const container = document.getElementById("root");
    if (container) {
      container.innerHTML = `
        <div style="padding: 20px; text-align: center; font-family: Arial, sans-serif;">
          <h2>Unable to Load Application</h2>
          <p>Your browser may not support the required features for this application.</p>
          <p>Please try using a more recent browser or contact support.</p>
          <p>Error: ${error instanceof Error ? error.message : "Unknown error"}</p>
        </div>
      `;
    }
  }
};

// Start the app
initializeApp();
